module.exports = __webpack_public_path__ + "static/media/Microsoft_logo.13c9a7ef.svg";